import { OverlayTrigger, Popover } from 'react-bootstrap'
import { components } from 'react-select'
import { FormattedMessage, injectIntl } from 'react-intl'

import styles from '../styles.module.css'
import messages from '../messages'

function MultiValueLabel(props) {
  return props.data.type === 'dimension' ? (
    <DimensionLabel {...props} />
  ) : (
    <DimensionValueLabel {...props} />
  )
}

const DimensionLabel = ({ children, ...props }) => {
  return (
    <OverlayTrigger
      delayShow={400}
      delayHide={150}
      placement="bottom"
      overlay={
        <Popover className={styles.popover} id={props.data.value}>
          <FormattedMessage {...messages.dimensionLabeltooltip} />
        </Popover>
      }
      trigger={['hover', 'focus']}
    >
      <div className={styles.valueLabelContainer}>
        <components.MultiValueLabel {...props}>
          <span className={styles.dimensionLabel}>{children}</span>
        </components.MultiValueLabel>
      </div>
    </OverlayTrigger>
  )
}

const DimensionValueLabel = ({ children, ...props }) => {
  const handleClick = (event) => {
    event.stopPropagation()
    if (props.selectProps?.onMultiValueClick) {
      props.selectProps.onMultiValueClick(props.data)
    }
  }

  return (
    <OverlayTrigger
      delayShow={400}
      delayHide={150}
      placement="bottom"
      overlay={
        <Popover className={styles.popover} id={props.data.value}>
          {props.data.path.length > 1
            ? props.data.path.slice(0, -1).join(' > ')
            : children}
        </Popover>
      }
      trigger={['hover', 'focus']}
    >
      <div className={styles.valueLabelContainer}>
        <components.MultiValueLabel
          {...props}
          innerProps={{
            ...props.innerProps,
            onClick: handleClick,
          }}
        >
          <span className={styles.dimensionValueLabel}>{children}</span>
        </components.MultiValueLabel>
      </div>
    </OverlayTrigger>
  )
}

export default injectIntl(MultiValueLabel)
